// GradientButton.js
import React from 'react';
import { Button, ConfigProvider } from 'antd';
import { TinyColor } from '@ctrl/tinycolor';

const colors = ['#e9ebe0', '#fdfef8'];
const getHoverColors = (colors) =>
  colors.map((color) => new TinyColor(color).lighten(5).toString());
const getActiveColors = (colors) =>
  colors.map((color) => new TinyColor(color).darken(5).toString());

const GradientButton = ({ children, ...props }) => (
  <ConfigProvider
    theme={{
      components: {
        Button: {
          color: '#3C210E',
          colorPrimary: `linear-gradient(135deg, ${colors.join(', ')})`,
          colorPrimaryHover: `linear-gradient(135deg, ${getHoverColors(colors).join(', ')})`,
          colorPrimaryActive: `linear-gradient(135deg, ${getActiveColors(colors).join(', ')})`,
          colorTextLightSolid: '#3C210E', // Set text color
          lineWidth: 0,
        },
      },
    }}
  >
    <Button type="primary" {...props}>
      {children}
    </Button>
  </ConfigProvider>
);

export default GradientButton;
